
import * as THREE from 'three'
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import Toast from 'vux/src/components/toast/index.vue'

import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


import { initThree, currentModel, updateModel, camera, renderer, scene } from './makeModel';

const contentList = [
"齐思印3D小软件",
"不负青春,不负自己",
"新年快乐",
"高考加油",
"祝你生日快乐",
"大吉大利,今晚吃鸡"
];


export default {
name: "lampshade",
mixins: [printModel],
components: {
Group,
XDialog,
Actionsheet,
Grid, GridItem, XNumber, XInput, Popup, Radio, Flexbox, FlexboxItem, Toast,
XTextarea, XButton
},
data() {
return {
quotationName: "3D创意灯",
productType:"3D创意灯",
landscape: true,//竖屏状态要一直为true
showPrint: false,
showText: false,
showSize: false,
wordData: {
fontSize: 30, // 长
d: 3, // 厚
text: contentList[Math.floor(Math.random() * contentList.length)],
font: "zcool-gdh",
Radian: 50
},
}
},
mounted() {
const scope = this;

var mo = function (e) {
e.preventDefault();
}


scope.$nextTick(function () {
scope.$refs.lampshade.style.paddingTop = '0px';
scope.$refs.lampshade.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
});


const contentDOM = scope.$refs.lampshade;

const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);


initThree(scope.$refs.canvas);
updateModel(this, this.wordData.font, this.wordData.text, this.wordData.fontSize, THREE.Math.degToRad(this.wordData.Radian));
},
methods: {
refresh3d() {
if (currentModel) {
scene.remove(currentModel);
updateModel(this, this.wordData.font, this.wordData.text, this.wordData.fontSize, THREE.Math.degToRad(this.wordData.Radian))
.then(() => {
console.log("currentModel", currentModel);
});
}
},


selectImgsList(){

},


selectAlbums(){

},


selectText() {
console.log("文本");
this.showText = !this.showText;
this.showPrint = false;
this.showSize = false;
},

cannelText() {
this.wordData.text = "";
},

setText() {
if (this.wordData.text === '' || this.wordData.text === null) {
this.$vux.toast.show({
text: '文本输入不能为空！',
type: "cancel",
time: 2000,
position: "middle",
});
this.wordData.text = "齐思印";
this.showText = true;
return;
}
this.showText = false;
this.refresh3d();
},


selectSize() {
this.showSize = !this.showSize;
this.showText = false;
this.showPrint = false;
},

canelPop() {
this.showSize = false;
},

isSure() {
if (this.wordData.fontSize < 30) {
this.$vux.toast.show({
text: '最小长度为30毫米',
type: "cancel",
time: 2000,
position: "middle",
});
return;
}

if (this.wordData.fontSize > 200) {
this.showSize = true;
this.$vux.toast.show({
text: '最大长度为200毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
}

if (this.wordData.d < 3) {
this.showSize = true;
this.$vux.toast.show({
text: '最小厚度为3毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
}

if (this.wordData.d > 10) {
this.showSize = true;
this.$vux.toast.show({
text: '最大厚度为10毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
}

if (this.wordData.Radian < 50) {
this.showSize = true;
this.$vux.toast.show({
text: '最小弧度为50毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
}

if (this.wordData.Radian > 80) {
this.showSize = true;
this.$vux.toast.show({
text: '最大弧度为80毫米',
type: "warn",
time: 2000,
position: "middle",
});
return;
}
this.showSize = false;
this.refresh3d();
},


print() {
this.showText = false;
this.showSize = false;



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showlowpriceHeight = true;
console.log("display:none 0就不显示", this.total);
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showlowpriceHeight = false;
console.log("1就是显示");
}


if (!this.$common.getCookie('_token')) {
this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
})

this.afterLoginShow = "print";
} else {
this.$nextTick(function () {
console.log("show print dialog");
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
});
}
},

makeStlBlob() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(currentModel, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},

getModelToPrint() { return currentModel; },
},
}



// WEBPACK FOOTER //
// ./src/views/lampshade3d/scripts/index.js